// extracted by mini-css-extract-plugin
export default {"wrapper":"FairwayRecommendation_wrapper__kK4TF"};